<template>
    <v-card>
        <v-card-title>Move Alarm Modification Rank</v-card-title>

        <!-- <v-divider></v-divider> -->

        <v-card-text>
            <v-form ref="moveToForm" @submit.prevent :lazy-validation="true" v-model="formValid">
                <span class="info-text">Change rank <b>{{$props.alarmMod.modif_rank}}</b> to rank: </span>
                <v-text-field class="mt-2 mr-3 new-rank" v-model="newRank" type="number" min="1" label="New Rank" outlined color="#c42111" :rules="[validation.required(newRank, 'New Rank'), validation.positiveInteger(newRank)]" />
                <v-btn tile color="#c42111" class="mr-1" @click="moveToTop"><v-icon>mdi-arrow-collapse-up</v-icon></v-btn>
                <v-btn tile color="#c42111" @click="moveToBottom"><v-icon>mdi-arrow-collapse-down</v-icon></v-btn>
            </v-form>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn text @click="$emit('cancel')">Cancel</v-btn>
            <v-btn text @click="okClick">Ok</v-btn>
        </v-card-actions>
    </v-card>
  
</template>

<script>
export default {
    name: 'AlarmModificationsMoveTo',
    props: ['alarmMod', 'maxRank'],
    components: {

    },
    data: () => ({
        formValid: true,
        newRank: null,
        validation: {
            required: (value, fieldName) => ((value || value === 0) ? true : false) || `${fieldName} is required`,
            positiveInteger: (value) => (value != null && (value.toString().indexOf('.') === -1) && (value.toString().indexOf('e') === -1) && (value.toString().indexOf('-') === -1) && parseInt(Number(value)) > 0) || `New Rank must be a positive integer`,
        }
    }),

    computed: {
    
    },

    methods: {
        moveToTop: function() {
            this.newRank = 1;
        },

        moveToBottom: function() {
            this.newRank = this.$props.maxRank;
        },

        okClick: function() {
            if(this.$refs.moveToForm.validate()) {
                if(Number(this.newRank) > Number(this.$props.maxRank)) {
                    this.newRank = Number(this.$props.maxRank);
                }
                this.$emit('ok', this.newRank);
            }
        }
    },

    mounted() {
    }

  
};
</script>

<style scoped>

    .info-text {
        display: block;
        margin-top: 1em;
    }

    .new-rank {
        display: inline-block;
        width: calc(100% - 150px);
    }

</style>
